import { eventEmitter } from "@/utils/event-emitter.js";
import { appState } from "@/utils/state.js";

export function showSolution() {
  eventEmitter.on("solution", () => {
    const boardArr = document.querySelectorAll(".cell");
    const puzzleArr = appState.getState("matrix").flat();
    appState.setState(
      "userInput",
      Array((appState.getState("levelInd") + 1) ** 2 * 25).fill(0)
    );
    eventEmitter.clear("userClick");
    puzzleArr.forEach((elem, i) => {
      boardArr[i].classList.toggle("x", false);
      if (elem === 1) {
        boardArr[i].classList.toggle("dark", true);
      }
    });
  });
}
